import axios from 'axios';

function getCsrfToken() {
  var meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

var instance = axios.create();

// Add CSRF token to every request
instance.interceptors.request.use(function(config) {
  config.headers['X-CSRF-Token'] = getCsrfToken();
  return config;
});

export default instance;
